(() => {
  'use strict';
  const setup = () => {
    const section = document.querySelector('[data-product-section]');
    const bar = section?.querySelector('[data-product-sticky]');
    const mainAdd = section?.querySelector('.purchase-actions__add');
    const stickyAdd = bar?.querySelector('[data-sticky-add]');
    const price = section?.querySelector('[data-price-current]');
    const stickyPrice = bar?.querySelector('[data-sticky-price]');
    if (!section || !bar || !mainAdd || !stickyAdd) return;

    const actions = section.querySelector('.purchase-actions');
    try {
      if (actions?.dataset.applePayEnabled === 'true' &&
          typeof window.ApplePaySession?.canMakePayments === 'function' &&
          window.ApplePaySession.canMakePayments()) {
        actions.classList.add('has-apple-pay');
      }
    } catch { /* Keep the standard checkout route when Apple Pay is unavailable. */ }

    let scrollQueued = false;
    const updateVisibility = () => {
      scrollQueued = false;
      const show = section.getBoundingClientRect().bottom < 0;
      bar.hidden = !show;
      document.body.classList.toggle('has-product-sticky', show);
    };
    const onScroll = () => {
      if (scrollQueued) return;
      scrollQueued = true;
      requestAnimationFrame(updateVisibility);
    };
    const sync = () => {
      if (price && stickyPrice) stickyPrice.textContent = price.textContent.trim();
      stickyAdd.disabled = mainAdd.disabled;
    };

    stickyAdd.addEventListener('click', () => {
      if (mainAdd.disabled) return;
      mainAdd.click();
    });
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    document.addEventListener('variant:change', sync);
    if (price) new MutationObserver(sync).observe(price, { childList: true, characterData: true, subtree: true });
    new MutationObserver(sync).observe(mainAdd, { attributes: true, attributeFilter: ['disabled'] });
    sync();
    updateVisibility();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
  else setup();
})();
